module.exports = __webpack_public_path__ + "img/group.51c1018c.jpg";